import { TradeFormState } from '../components/TradePage/TradeForm/TradeFormState';
import { Gwei } from './gwei';
import { divide, multiply } from './math';

export const newPositionSize = (
  currentPositionSize: bigint,
  orderAmount: bigint,
  side: TradeFormState['side']
) => (side === 'long' ? currentPositionSize + orderAmount : currentPositionSize - orderAmount);

export const isOppositeSide = (posSize1: bigint, posSize2: bigint) => posSize1 * posSize2 < 0n;

export const calcPnl = (currentPrice: bigint, avgPrice: bigint, size: bigint) =>
  multiply(currentPrice - avgPrice, size);

export const calcPnlWithFees = (
  currentPrice: bigint,
  avgPrice: bigint,
  size: bigint,
  feeRate: bigint
) => {
  // First calculate base PnL
  const pnl = calcPnl(currentPrice, avgPrice, size);
  // Calculate fees
  const fees = multiply(multiply(currentPrice, Gwei.abs(size)), feeRate);
  // Subtract fees from PnL
  return pnl - fees;
};

export const calcPnlPercentage = (currentPrice: bigint, avgPrice: bigint, size: bigint) => {
  const notionalPercentageChange = divide(currentPrice - avgPrice, avgPrice);
  return size > 0n ? notionalPercentageChange : Gwei.flipSide(notionalPercentageChange);
};

export const isPositionFillOpenOrClose = ({
  pageIndex,
  fillIndex,
  sortOrder,
  fillsLength,
  pagesLength,
  hasNextPage,
}: {
  pageIndex: number;
  fillIndex: number;
  sortOrder: 'asc' | 'desc';
  fillsLength: number;
  pagesLength: number;
  hasNextPage: boolean;
}) => {
  if (sortOrder === 'asc') {
    // In ascending order:
    // - First fill is at the beginning of the first page
    // - Last fill is at the end of the last page
    return {
      isFirstFill: pageIndex === 0 && fillIndex === 0,
      isLastFill: !hasNextPage && pageIndex === pagesLength - 1 && fillIndex === fillsLength - 1,
    };
  } else {
    // In descending order:
    // - First fill is at the end of the last page
    // - Last fill is at the beginning of the first page
    return {
      isFirstFill: !hasNextPage && pageIndex === pagesLength - 1 && fillIndex === fillsLength - 1,
      isLastFill: pageIndex === 0 && fillIndex === 0,
    };
  }
};
